<script setup lang="ts">
    import { useSpaceStore, useAuthStore, useDataCacheStore } from "~/stores"
    import { computed, defineProps } from "vue"

    const spaceStore = useSpaceStore()
    const dataCacheStore = useDataCacheStore()

    const props = defineProps({
        currentProject: {
            type: Object,
        },
    })

    const authStore = useAuthStore()

    const personnel = computed(() => {
        return (
            props.currentProject?.responsableProjet ||
            authStore.getUser?.commercial
        )
    })

    const company = computed(() => dataCacheStore.data?.COMPANY)
</script>

<template>
    <div>
        <div class="user-informations">
            <SpaceSectionLayout class="card">
                <h4>Votre commercial</h4>

                <div class="commercial-wrapper">
                    <div class="commercial">
                        <AppAvatar
                            :color="spaceStore.getColor"
                            :personnel_id="personnel?.IDPERSONNEL"
                            size="56"
                        />
                        <div class="commercial-info">
                            <p class="commercial-name">
                                {{ personnel?.PRENOM }} {{ personnel?.NOM }}
                            </p>
                            <div class="commercial-contact">
                                <a
                                    v-if="personnel?.MAIL"
                                    :href="`mailto:${personnel.MAIL}`"
                                    class="contact-link"
                                >
                                    <v-icon size="14">mdi-email-outline</v-icon>
                                    {{ personnel?.MAIL }}
                                </a>
                                <a
                                    v-if="personnel?.TELEPHONE_PORTABLE"
                                    :href="`tel:${personnel.TELEPHONE_PORTABLE}`"
                                    class="contact-link"
                                >
                                    <v-icon size="14">mdi-phone-outline</v-icon>
                                    {{ personnel?.TELEPHONE_PORTABLE }}
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- Avis Google -->
                    <div v-if="company?.GOOGLE_RATING" class="google-reviews">
                        <v-icon color="#FBBC04" size="18">mdi-star</v-icon>
                        <span class="google-rating">{{
                            company.GOOGLE_RATING.toFixed(1)
                        }}</span>
                        <span class="google-count"
                            >({{ company.GOOGLE_REVIEW_COUNT }} avis)</span
                        >
                        <v-icon size="16" class="ml-1">mdi-google</v-icon>
                    </div>
                </div>
            </SpaceSectionLayout>
            <SpaceSectionLayout class="card">
                <h4>Votre Agence</h4>
                <div class="agence">
                    <p>{{ spaceStore?.getAgence?.NOM_AGENCE }}</p>
                    <p>{{ spaceStore?.getAgence?.ADRESSE?.ADRESSE }}</p>
                    <p>
                        {{ spaceStore?.getAgence?.ADRESSE?.CODE_POSTAL }}
                        {{ spaceStore?.getAgence?.ADRESSE?.VILLE }}
                    </p>
                    <p class="red--text">
                        {{ spaceStore?.getAgence?.TELEPHONE }}
                    </p>
                </div>
            </SpaceSectionLayout>
        </div>
    </div>
</template>

<style scoped>
    .user-informations {
    display: flex;
    justify-content: space-around;
    position: relative;
    top: -20px;
}

.card {
    padding: 20px 20px 20px 20px;
}

.commercial-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
}

.commercial {
    display: flex;
    align-items: center;
    gap: 12px;
}

.commercial-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.commercial-name {
    font-weight: 600;
    font-size: 14px;
    margin: 0 !important;
}

.commercial-contact {
    display: flex;
    gap: 16px;
}

.contact-link {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #555;
    text-decoration: none;
    transition: color 0.2s;
}

.contact-link:hover {
    color: #000;
}

.google-reviews {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 10px;
    background-color: #f8f9fa;
    border-radius: 6px;
    flex-shrink: 0;
}

.google-rating {
    font-size: 1rem;
    font-weight: 700;
    color: #333;
}

.google-count {
    font-size: 0.8rem;
    color: #666;
}

.agence {
    display: flex;
    flex-direction: column;
    line-height: 32px;
}

@media (max-width: 768px) {
    .user-informations {
        flex-direction: column;
        gap: 0;
        align-items: stretch;
        padding: 0 10px;
    }

    .card {
        padding: 15px;
    }

    .card :deep(.v-card) {
        margin-bottom: 10px !important;
    }

    .commercial-wrapper {
        flex-direction: column;
        align-items: flex-start;
    }

    .commercial-contact {
        flex-direction: column;
        gap: 6px;
    }

    .google-reviews {
        margin-top: 12px;
    }
}

h2 {
    font-family: Inter, sans-serif;
    font-size: 20px;
    font-weight: 600;
    text-align: left;
}

h3 {
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 600;
    text-align: left;
    margin-bottom: 25px;
}

h4 {
    margin-bottom: 25px;
}

p {
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 400;
    text-align: left;
    margin-top: -15px;
}
</style>
